module.exports = ".activity-list-link {\r\n    padding-top: 20px;\r\n}\r\n"